export default class LimitResult {

    constructor(jsonResponse) {
        this.dailyLimitReached = jsonResponse["daily-limit-reached"];
        this.dailyLimitRemaining = jsonResponse["daily-limit-remaining"];
        this.monthlyLimitReached = jsonResponse["monthly-limit-reached"];
        this.monthlyLimitRemaining = jsonResponse["monthly-limit-remaining"];
    }
}
